export default "__VITE_ASSET__CEIwKhBp__"